module.exports = __webpack_public_path__ + "Lato-Hairline.ada4458b361d5e72bcbd.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Hairline.woff2
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Hairline.woff2
// module chunks = styles